import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap5';

import LoadingPlaceholder from 'components/new_ui/WaitLayers/LoadingPlaceholder';

export default function SubmitButton({ loading, disabled, children }) {
  return (
    <Button
      type="submit"
      disabled={disabled || loading}
    >
      {loading && <LoadingPlaceholder placement="inline" text=" " />}
      {children}
    </Button>
  );
}

SubmitButton.propTypes = {
  loading: PropTypes.bool.isRequired,
  disabled: PropTypes.bool,
  children: PropTypes.string.isRequired,
};

SubmitButton.defaultProps = {
  disabled: false,
};
